<template>
  <div>
    <video-header>优选产品</video-header>
    <div class="yxcp">
      <div class="yxcpmain" v-if="productlist.length>0" @click="getuserxcxpath(productlist[0].id)">
        <img :src="productlist[0].productCoverImg" alt />
        <div>{{productlist[0].productName}}</div>
        <div>￥{{productlist[0].minPrice}}</div>
      </div>
      <div class="yxcpmain01" v-if="productlist.length>1">
        <template v-for="(item,index) in productlist">
          <div :key="index" v-if="index>0" @click="getuserxcxpath(item.id)">
            <img :src="item.productCoverImg" alt />
            <div>{{item.productName}}</div>
            <div>￥{{item.minPrice}}</div>
          </div>
        </template>
      </div>
    </div>

    <div class="dialog" v-if="isshowm" @click="isshowmtap()">
      <div>
        <img :src="erweima.programPicUrl" alt @click.stop />
        <!-- <img :src="productlist[0].productCoverImg" alt /> -->
      </div>
    </div>
  </div>
</template>

<script>
import videoHeader from "../../components/Header";
export default {
  name: "yxcp",
  components: {
    videoHeader
  },
  data() {
    return {
      page: 1,
      rows: 100,
      unionmallid: "",
      productlist: [],
      erweima: {},
      isshowm: false
    };
  },
  mounted() {
    this.searchproductlist();
  },
  methods: {
    searchproductlist() {
      this.$axios({
        url: `https://baotuquan.shop/peddler/apiProduct/product/searchproductlist`,
        method: "GET",
        params: {
          page: this.page,
          rows: this.rows,
          league: 'UB7882418168667504640',
          optimization: true
        }
      })
        .then(res => {
          if (res.data.code == 0) {
            this.productlist = res.data.data.info.items;
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    getuserxcxpath(productId) {
      this.$axios({
        url: `https://baotuquan.shop/peddler/apiAuth/wechat/getuserxcxpath`,
        method: "POST",
        data: {
          xcxRealPage: "pages/detail/detail?id=",
          transitionalPage: "pages/detail/detail?id=",
          xcxName: "PEDDLER",
          progarmPath: "pages/detail/detail",
          sceneParam: productId,
          module: 6
        }
      })
        .then(res => {
          if (res.data.code == 0) {
            this.erweima = res.data.data;
            this.isshowm = true;
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    isshowmtap() {
      this.isshowm = false;
    }
  }
};
</script>

<style scoped>
.yxcpmain {
  background: rgba(255, 255, 255, 1);
  border-radius: 0px 0px 5px 5px;
  padding: 15px;
  box-sizing: border-box;
}
.yxcpmain > img {
  width: 100%;
  height: 180px;
}
.yxcpmain > div:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
}
.yxcpmain > div:nth-child(3) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 68, 68, 1);
  line-height: 24px;
}
.yxcpmain01 {
  padding-bottom: 15px;
}
.yxcpmain01 > div {
  margin-top: 15px;
  display: inline-block;
  width: calc((100vw - 45px) / 2);
  margin-left: 15px;
  vertical-align: top;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  position: relative;
  height: 240px;
}
.yxcpmain01 > div > img {
  width: calc(100%);
  height: calc(((100vw - 45px) / 2) - 20px);
}
.yxcpmain01 > div > div:nth-child(2) {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
}
.yxcpmain01 > div > div:nth-child(3) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 68, 68, 1);
  line-height: 24px;
  position: absolute;
  left: 10px;
  bottom: 10px;
}
.yxcp {
  background: #f2f3f7;
}
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
}

.dialog > div {
  text-align: center;
}

.dialog > div > img {
  width: 90%;
  margin-top: 100px;
}
</style>